import { render, staticRenderFns } from "./ChangeConsultantPhysicalFranchiseSidebar.vue?vue&type=template&id=0fd74495"
import script from "./ChangeConsultantPhysicalFranchiseSidebar.vue?vue&type=script&lang=js"
export * from "./ChangeConsultantPhysicalFranchiseSidebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports